export function ChevronDownSmall() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.46967 8.96967C5.76256 8.67678 6.23744 8.67678 6.53033 8.96967L12 14.4393L17.4697 8.96967C17.7626 8.67678 18.2374 8.67678 18.5303 8.96967C18.8232 9.26256 18.8232 9.73744 18.5303 10.0303L12.5303 16.0303C12.2374 16.3232 11.7626 16.3232 11.4697 16.0303L5.46967 10.0303C5.17678 9.73744 5.17678 9.26256 5.46967 8.96967Z"
        fill="#101010"
      />
    </svg>
  )
}
